import { Box } from 'braid-design-system';
import type { ComponentProps } from 'react';

interface Props {
  color?: string;
  type?: 'dark' | 'light';
  children: React.ReactNode;
}

type BoxProps = ComponentProps<typeof Box>;
const customColorMode: Record<
  NonNullable<Props['type']>,
  Extract<BoxProps['background'], 'customDark' | 'customLight'>
> = { dark: 'customDark', light: 'customLight' } as const;

const Banner = ({ color = '#3f51b5', type = 'dark', children }: Props) => (
  <Box background={customColorMode[type]} style={{ backgroundColor: color }}>
    {children}
  </Box>
);

export default Banner;
